import { ReactNode, useLayoutEffect, useRef, useState } from 'react';
import './costBreakdown.css';

/** Preserve natural tablet sizing; expose navigation only while columns actually overflow. */
export const CostBreakdown = ({ label, children }: { label: string; children: ReactNode }) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [overflowing, setOverflowing] = useState(false);

  useLayoutEffect(() => {
    const scroller = scrollRef.current;
    if (!scroller) return;
    const measure = () => setOverflowing(scroller.scrollWidth > scroller.clientWidth + 1);
    measure();
    const observer =
      typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver(measure);
    observer?.observe(scroller);
    const table = scroller.querySelector('table');
    if (table) observer?.observe(table);
    return () => observer?.disconnect();
  }, []);

  return (
    <div className="cost-breakdown min-w-0 max-w-full" data-overflow={overflowing}>
      {overflowing && (
        <p className="cost-breakdown-hint mb-2 text-sm">
          Scroll horizontally to see all rates, hours and totals.
        </p>
      )}
      <div
        ref={scrollRef}
        role={overflowing ? 'region' : undefined}
        aria-label={overflowing ? label : undefined}
        tabIndex={overflowing ? 0 : undefined}
        className="max-w-full overflow-x-auto"
      >
        <div className="cost-breakdown-content">{children}</div>
      </div>
    </div>
  );
};
